import { IOnInit } from "angular";
import {
  AuthorizedUiElementService,
  AuthorizedUiElementConfig,
} from "../../../../../../../ui/authorizedUiElement";
import { vsServiceName as machineDetailTabsServiceName } from "./machineDetailTabsService";

export class MachineDetailTabsController implements IOnInit {
  static $inject = [machineDetailTabsServiceName];

  private pageIndex: number = 0;
  private pageSize: number = 5;
  private pageCount: number = 0;

  constructor(
    private readonly machineDetailTabsService: AuthorizedUiElementService<AuthorizedUiElementConfig>
  ) {}

  $onInit(): void {
    const tabCount = this.machineDetailTabsService.getConfigs().length;
    this.pageCount = Math.floor((tabCount - 1) / this.pageSize) + 1;
    this.pageCount = Math.max(this.pageCount, 0);
  }

  getTabs(): AuthorizedUiElementConfig[] {
    const skip = this.pageIndex * this.pageSize;
    return this.machineDetailTabsService
      .getConfigs()
      .slice(skip, skip + this.pageSize);
  }
}
